<template>
    <div class="px-2 pb-2 pt-6 text-left">
        <!-- <img @click="back" src="../../assets/back.png" class="fixed left-2 top-5"/> -->
        <div @click="back" class="back border rounded-sm flex justify-center items-center mb-2">返回</div>
        <p class="font-bold" style="font-size: .55rem;">➢什么是CBT-I</p>
        <p>失眠认知行为疗法（Cognitive Behavioral Therapy for Insomnia，简称 CBT-I）是一种针对失眠问题的系统性干预方法。它并非传统意义上的医学治疗手段，而是一种心理训练方案，旨在通过调整患者的思维和行为模式来改善睡眠质量。</p>
        <p>CBT-I 的定义可以理解为一套综合性的心理策略和行为干预措施的集合。其核心目标是帮助个体识别并改变那些可能导致或加重失眠的不良认知和行为习惯。具体而言，CBT-I 关注个体在睡眠前后的思维、情绪和行为，通过针对性的训练来调整这些因素，从而促进更健康、更高效的睡眠。</p>
        <p>CBT-I 具有以下几个显著特点：</p>
        <p class="indent">1.首先，它是一种基于科学研究和实证证据的方法。众多临床研究和实践经验都证明了其在改善失眠症状方面的有效性。</p>
        <p class="indent">2.CBT-I 是一种个性化的干预方案。每个个体的失眠原因和表现可能各不相同，CBT-I 会根据不同个体的具体情况，制定专属的训练计划，以确保干预的针对性和有效性。</p>
        <p class="indent">3.CBT-I 强调个体的主动参与和自我管理。与依赖药物治疗不同，个体在 CBT-I 过程中需要积极配合，改变自己的思维和行为习惯，这对于长期维持良好的睡眠状态至关重要。</p>
        <p>需要明确的是，CBT-I 不是一种治疗手段，而是一种心理训练方案。这一特点使其与传统的药物治疗或医学干预方法有着本质的区别。在传统的治疗观念中，药物治疗通常直接作用于生理机制，以达到缓解症状的目的。而 CBT-I 则侧重于通过训练个体的心理和行为，来调整睡眠模式和习惯。它不依赖外部药物的介入，而是依靠个体自身的内在力量和资源来实现睡眠的改善，也就使得个体能在训练结束后，依然保持良好的睡眠状态，减少失眠症状的复发。相比之下，药物治疗在停止用药后，失眠症状往往容易再次出现。</p>
        <p>此外，CBT-I 对个体的整体心理健康也具有积极的影响。在改善睡眠的同时，它有助于减轻焦虑、抑郁等与失眠相关的负面情绪，提升个体的心理韧性和应对压力的能力。这种全方位的改善效果是单纯的药物治疗难以达到的。</p>
        <p>然而，CBT-I 也并非适用于所有失眠患者。对于某些由于严重的生理疾病或器质性病变导致的失眠，可能需要结合药物治疗或其他医学手段来共同解决问题。但在大多数情况下，特别是对于原发性失眠和由心理因素引发的失眠，CBT-I 都能发挥重要的作用。</p>
        <p class="font-bold mt-4" style="font-size: .55rem;">➢CBT-I训练方案的主要内容</p>
        <p>1.睡眠日记</p>
        <p class="indent">睡眠日记是个体对自身睡眠情况的详细记录，通常包括每天上床睡觉的时间、入睡所需的时间、夜间醒来的次数和时间、早晨醒来的时间、总睡眠时间以及对睡眠质量的主观评价等内容。</p>
        <p class="indent">通过记录睡眠日记，个体能够更清晰地了解自己的睡眠模式和规律，也能根据睡眠日记中的数据，准确评估个体的睡眠状况，如睡眠潜伏期（入睡时间）、睡眠效率（实际睡眠时间与在床上时间的比率）等。这些数据为制定个性化的 CBT-I 方案提供了关键依据。比如，如果睡眠日记显示入睡时间过长，那么可能会建议采用刺激控制法，减少在床上清醒的时间。如果总睡眠时间较短，可能会通过睡眠限制法来调整。</p>
        <p>2.睡眠限制</p>
        <p class="indent">睡眠限制是根据个体的实际睡眠情况，来限制其在床上的时间。CBT-I训练方案会要求个体记录睡眠日记，包括上床时间、入睡时间、觉醒次数、总睡眠时间等。基于这些数据，计算个体的平均睡眠时间，并以此为基础，适当缩短在床上的时间。例如，如果用户平均每晚睡眠时间为 5 小时，但在床上的时间为 8 小时，那么可能会建议将在床上的时间限制在 5.5 小时左右。随着睡眠质量的改善，逐步增加在床上的时间。这种方法能够增加睡眠驱动力，提高睡眠效率。</p>
        <p>3.刺激控制</p>
        <p class="indent">刺激控制是 CBT-I 的重要策略之一。其核心原则是重新建立床与睡眠之间的积极联系。当感到困倦时才上床睡觉，如果在床上 15 - 20 分钟仍无法入睡，应离开床并进行一些放松活动，直到再次感到困倦。避免在床上进行与睡眠无关的活动，如看电视、使用电子设备或阅读紧张刺激的书籍。每天都在相同的时间起床，无论前一晚的睡眠质量如何。通过这样的方式，逐渐强化床作为睡眠暗示的作用，减少在床上的清醒时间，从而提高睡眠效率。</p>
        <p>4.认知疗法</p>
        <p class="indent">许多失眠群体存在对睡眠的不合理认知和担忧，例如过度担心睡眠不足对健康的影响，或者对入睡困难产生恐惧和焦虑。认知疗法旨在帮助个体识别和改变这些负面的思维模式。例如，纠正个体对失眠后果的过度夸大认知，明白偶尔的睡眠不足并不会带来严重的健康问题；帮助用户调整对睡眠的期望，认识到每个人的睡眠需求是不同的，不必追求每晚都达到理想的睡眠时间。通过改变这些不合理的认知，减轻心理压力，从而改善睡眠状况。</p>
        <p>5.放松训练</p>
        <p class="indent">放松训练在 CBT-I 中也发挥着重要作用，常见的放松技巧包括深呼吸练习、渐进性肌肉松弛和冥想等。深呼吸练习时，个体可以慢慢地吸气，然后缓缓地呼气，专注于呼吸的节奏和感受，帮助身体和思维放松。渐进性肌肉松弛则是通过依次紧张和放松身体的各个肌肉群，如从脚部开始，逐渐向上到腿部、臀部、腹部、胸部、手臂和脸部，让身体感受到深度的放松。冥想可以引导个体将注意力集中在当下的感受和思绪上，不做评判，让内心平静下来。这些放松训练能够减轻身体的紧张感和心理的焦虑，为入睡创造有利条件。</p>
        <p>6.睡眠卫生教育</p>
        <p class="indent">睡眠卫生教育是 CBT-I 的基础部分。它着重向个体传授关于良好睡眠习惯的知识和实践方法。例如，保持规律的作息时间至关重要，每天在相同的时间上床睡觉和起床，有助于调整人体的生物钟，使其适应固定的睡眠 - 觉醒周期；创建一个安静、舒适、黑暗且温度适宜的睡眠环境能够促进睡眠；选择舒适的床垫和枕头，减少噪音和光线的干扰，都有利于提高睡眠质量；避免在晚上摄入咖啡因、尼古丁和大量液体，以免影响睡眠；另外，限制白天的午睡时间，过长的午睡可能会影响夜间的睡眠驱动力等等。</p>
        <p class="mb-4">综上所述，CBT-I 所包含的睡眠日记、睡眠限制、刺激控制、认知疗法、放松训练、睡眠卫生教育等内容相互协同，从行为习惯、环境调整、心理认知等多个方面入手，为个体提供了一套全面而有效的心理训练方案，为饱受失眠困扰的人们提供了一条全新且有效的解决途径，帮助他们重新拥抱高质量的睡眠，提升生活的整体品质。</p>


        <p class="font-bold" style="font-size: .55rem;">参考文献：</p>
        
        <p>Alimoradi, Z., Jafari, E., Broström, A., Ohayon, M. M., Lin, C. Y., Griffiths, M. D., ... & Pakpour, A. H. (2022). Effects of cognitive behavioral therapy for insomnia (CBT-I) on quality of life: A systematic review and meta-analysis. Sleep medicine reviews, 64, 101646.</p>
        <p>Bastien, C. H., Morin, C. M., Ouellet, M. C., Blais, F. C., & Bouchard, S. (2004). Cognitive-behavioral therapy for insomnia: comparison of individual therapy, group therapy, and telephone consultations. Journal of consulting and clinical psychology, 72(4), 653.</p>
        <p>Koffel, E. A., Koffel, J. B., & Gehrman, P. R. (2015). A meta-analysis of group cognitive behavioral therapy for insomnia. Sleep medicine reviews, 19, 6-16.</p>
        <p>Koffel, E., Bramoweth, A. D., & Ulmer, C. S. (2018). Increasing access to and utilization of cognitive behavioral therapy for insomnia (CBT-I): a narrative review. Journal of general internal medicine, 33, 955-962.</p>
        <p>Mitchell, M. D., Gehrman, P., Perlis, M., & Umscheid, C. A. (2012). Comparative effectiveness of cognitive behavioral therapy for insomnia: a systematic review. BMC family practice, 13, 1-11.</p>
        <p>Morin, C. M. (2006). Cognitive-behavioral therapy of insomnia. Sleep Medicine Clinics, 1(3), 375-386.</p>
        <p>Natsky, A. N., Vakulin, A., Chai-Coetzer, C. L., Lack, L., McEvoy, R. D., Lovato, N., ... & Kaambwa, B. (2020). Economic evaluation of cognitive behavioural therapy for insomnia (CBT-I) for improving health outcomes in adult populations: a systematic review. Sleep Medicine Reviews, 54, 101351.</p>
        <p>Taylor, D. J., & Pruiksma, K. E. (2014). Cognitive and behavioural therapy for insomnia (CBT-I) in psychiatric populations: a systematic review. International review of psychiatry, 26(2), 205-213.</p>
        <p>van der Zweerde, T., Bisdounis, L., Kyle, S. D., Lancee, J., & van Straten, A. (2019). Cognitive behavioral therapy for insomnia: a meta-analysis of long-term effects in controlled studies. Sleep medicine reviews, 48, 101208.</p>
        <p>Wagley, J. N., Rybarczyk, B., Nay, W. T., Danish, S., & Lund, H. G. (2013). Effectiveness of abbreviated CBT for insomnia in psychiatric outpatients: sleep and depression outcomes. Journal of clinical psychology, 69(10), 1043-1055.</p>
        <p class="mb-10"></p>
    </div>
</template>

<script>
import Xc from "../../js/xinchao"
export default {
    data(){
        return {

        }
    },
    created(){

    },
    mounted(){

    },
    methods:{
        back(){
            console.log("返回咯");
            Xc.callAppRouter("closeWindow",{},function(err,res) {})
            // window.close()

            //history.back()
        },
    },
}
</script>

<style lang='scss' scoped>
.indent{
    text-indent: 2em;
}
.back{
    width: px2html(60px);
    height: px2html(30px);
}
img{

    width: px2html(30px);
}
</style>